import styled from 'styled-components';
import { SearchInputField } from './common/common-search.styles';
import breakpoint from '~/utils/style-utils';

export const DesktopSearchWrapper = styled.div<{ inSearchRoute: boolean }>`
	position: relative;
	display: flex;
	flex-basis: 220px;
	padding: 10px 0;
	flex: ${({ inSearchRoute }) => (inSearchRoute ? '1 0 100%' : '0 1 220px')};
	z-index: 1;
	transition: flex-basis 300ms ease-in-out;
`;

export const DesktopSearchInput = styled(SearchInputField)`
	background-color: var(--search-bg-large, rgba(var(--base-03), 1));
	color: var(--search-text-small, rgba(var(--base-11), 1));
	${breakpoint.md`
		color: var(--search-text-large, rgba(var(--base-11), 1));
`}
	width: 100%;
	height: 36px;
	line-height: 36px;
	border-radius: 6px;
	&::placeholder {
		color: var(--search-text, rgba(var(--base-11), 1));
		${breakpoint.md`
		color: var(--search-text-desktop-placeholder, rgba(var(--base-11), 1));
`}
	}
	&::-ms-input-placeholder {
		color: var(--search-text, rgba(var(--base-11), 1));
		${breakpoint.md`
		color: var(--search-text-desktop-placeholder, rgba(var(--base-11), 1));
`}
	}
	::-moz-placeholder {
		color: var(--search-text, rgba(var(--base-11), 1));
		${breakpoint.md`
		color: var(--search-text-desktop-placeholder, rgba(var(--base-11), 1));
`}
	}
	::-webkit-input-placeholder {
		color: var(--search-text, rgba(var(--base-11), 1));
		${breakpoint.md`
		color: var(--search-text-desktop-placeholder, rgba(var(--base-11), 1));
`}
	}
`;

export const SearchResultsWrapper = styled.div`
	height: calc(100vh - var(--smallerHeaderHeight) + var(--searchBarHeight));
	width: 100vw;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	article + article {
		margin-top: 12px;
	}
	padding: 12px;
	background-color: var(--search-results-bg);
`;

export const SearchResultsDesktopWrapper = styled.div`
	overflow-y: auto;
	padding: 12px 24px;
	&::-webkit-scrollbar {
		display: none;
	}
	background-color: var(--desktop-results-wrapper-bg-color);
`;

export const SearchResultTextWrapperDesktop = styled.div`
	padding: 12px 24px;
`;

export const SearchResultTextWrapperMobile = styled.div`
	padding: 20px 0;
	font: var(--h3);
`;

export const SearchResultsNoResultsDesktop = styled.p`
	font: var(--search-no-results-desktop-text-font);
	color: var(--search-no-results-desktop-text-color);
`;

export const SearchResultsNoResultsMobile = styled.p`
	font: var(--search-no-results-text-font);
	color: var(--search-no-results-text-color);
`;
